export const FileTypes = [
    {
        label: 'Masivian',
        value: 'MASIVIAN'
    },
    {
        label: 'Facturas del icetex',
        value: 'FACTURAS_ICETEX'
    },
];